import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

import { normalizeStationSearch, StationSearch } from './models/station-search';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GlobalStationSearchService {
  private http = inject(HttpClient);
  private url = environment.url.bffV3;

  searchStation(
    filter: { name: string } = { name: '' },
    page = 1
  ): Observable<StationSearch[]> {
    const rawName = typeof filter?.name === 'string' ? filter.name : '';
    const name = rawName.trim();

    if (name.length < 3) {
      return of([]);
    }

    const fullUrl = `${this.url}/station/search/${encodeURIComponent(name)}`;

    return this.http.get<any[]>(fullUrl).pipe(
      map(response => {
        const items = Array.isArray(response) ? response : [];
        const normalized = items
          .map(normalizeStationSearch)
          .filter((station): station is StationSearch => station !== null)
          .filter(station =>
            station.name.toLowerCase().includes(name.toLowerCase())
          );

        return this.deduplicateById(normalized);
      }),
      catchError(error => {
        console.error('searchStation failed:', error);
        return of([]);
      })
    );
  }

  private deduplicateById(stations: StationSearch[]): StationSearch[] {
    const seen = new Set<number>();

    return stations.filter(station => {
      if (seen.has(station.id)) {
        return false;
      }
      seen.add(station.id);
      return true;
    });
  }
}
